export const smo = {
	message: '',
	sender: '',
};
